export const LOADED_SEGMENT_PROPOSAL_STORAGE_KEY = 'nm.loadedSegmentProposal';
export const OPTIMIZE_ACTIVE_SUB_STORAGE_KEY = 'nm.optimizeActiveSub';

export function persistLoadedSegmentProposal({ id, name } = {}) {
  const proposalId = String(id || '').trim();
  if (!proposalId) return;
  try {
    sessionStorage.setItem(
      LOADED_SEGMENT_PROPOSAL_STORAGE_KEY,
      JSON.stringify({
        id: proposalId,
        name: String(name || '').trim() || proposalId,
      }),
    );
  } catch {
    // ignore quota / private mode
  }
}

export function readLoadedSegmentProposal() {
  try {
    const raw = sessionStorage.getItem(LOADED_SEGMENT_PROPOSAL_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const id = String(parsed?.id || '').trim();
    if (!id) return null;
    return {
      id,
      name: String(parsed?.name || '').trim() || id,
    };
  } catch {
    return null;
  }
}

export function clearLoadedSegmentProposal() {
  try {
    sessionStorage.removeItem(LOADED_SEGMENT_PROPOSAL_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function readOptimizeActiveSub(fallback = 'optimize-meta') {
  try {
    const stored = sessionStorage.getItem(OPTIMIZE_ACTIVE_SUB_STORAGE_KEY);
    if (stored) return stored;
  } catch {
    // ignore
  }
  return fallback;
}

export function persistOptimizeActiveSub(subTab) {
  if (!subTab) return;
  try {
    sessionStorage.setItem(OPTIMIZE_ACTIVE_SUB_STORAGE_KEY, subTab);
  } catch {
    // ignore
  }
}
